import { FC } from "react";
import InputForm from "./Input";

interface TextareaProps {
  name: string;
  label: string;
  rows?: number;
}

const Textarea: FC<TextareaProps> = ({ name, label, rows = 3 }) => (
  <InputForm name={name} label={label} rows={rows} multiline />
);

export default Textarea;
